document.addEventListener('DOMContentLoaded', () => {
    var swiperlist_box = new Swiper('.specificationlist-m', {
      slidesPerGroup: 1,
      slidesPerView: 5,
      observer: true,
      observeParents: true,
      watchOverflow: true,
      slidesPerView: 5,
      spaceBetween: 0,
      breakpoints: {
        900: {
          slidesPerView: 5,
          spaceBetween: 0,
        },
        500: {
          slidesPerView: 3,
          spaceBetween: 0,
        },
        300: {
          slidesPerView: 2,
          spaceBetween: 0,
        },
      },
    });
  });